import * as React from 'react';

interface PaginationButtonsProps {
  pageSize: number;
  currentPage: number;
  wavesCount: number;
  setCurrentPage: (pageNumber: number) => void;
}

/**
 * @deprecated - Props are domain-specific, and it is not portable (relies on CSS via the class name).
 * Prefer "app/javascript/components/shared/PaginationButtons.tsx" instead.
 */
const PaginationButtons: React.FC<PaginationButtonsProps> = (props) => {
  const pageBack = () => {
    if (props.currentPage > 1) {
      props.setCurrentPage(props.currentPage - 1);
    }
  };

  const pageForward = () => {
    const pageSize = props.pageSize;
    const endIndexThisPage = (props.currentPage - 1) * pageSize + pageSize;
    if (endIndexThisPage < props.wavesCount) {
      props.setCurrentPage(props.currentPage + 1);
    }
  };

  const wavesCountDisplay = () => {
    const pageSize = props.pageSize;
    const totalRecords = props.wavesCount;
    let startIndex;

    if (props.wavesCount > 0) {
      startIndex = (props.currentPage - 1) * pageSize + 1;
    } else {
      startIndex = 0;
    }
    const endIndex = Math.min((props.currentPage - 1) * pageSize + pageSize, totalRecords);
    return (
      <span>
        <strong>
          {startIndex}-{endIndex}
        </strong>{' '}
        of {totalRecords}
      </span>
    );
  };

  return (
    <div className="shipments-index-bubble-container">
      <a
        className="shipments-page-back"
        onClick={() => {
          pageBack();
        }}
      >
        <i className="fa fa-angle-left"></i>
      </a>
      <span className="shipments-page-counter">{wavesCountDisplay()}</span>
      <a
        className="shipments-page-forward"
        onClick={() => {
          pageForward();
        }}
      >
        <i className="fa fa-angle-right"></i>
      </a>
    </div>
  );
};

export default PaginationButtons;
